import React from 'react';
import './Loading.scss';

class Loading extends React.Component {
    render() {
        return (
            <>
                {this.props.show && (
                    <div className="ebs-loading-container">
                        <div className="ebs-loading-box">
                            <div className="spinner-border text-primary" role="status" />
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export default Loading;